import Actions from '../constants/Actions';
import request from 'superagent';

export async function populateClientConfig(context, config) {
  context.dispatch(Actions.CONFIG__LOADED, config);
}

export async function retrieveBuildVersion(context) {
  const result = await request.get('/status');

  if (result.ok) {
    const {body: {build = {}} = {build: {}}} = result;

    context.dispatch(Actions.CONFIG__BUILD_DATA_RECEIVED, build);
  }
}



// WEBPACK FOOTER //
// ./src/actions/ConfigActionCreators.js